import { ErrorManagement } from '@printdeal/error-management/react';
import { ServiceFactory } from '../../../services/ServiceFactory';

export const clearZendeskConversationMessagesOnServer = async (
  conversationId: string,
): Promise<void> => {
  try {
    const zendeskService = ServiceFactory.createZendeskTicketService();

    await zendeskService.clearConversationMessages(conversationId);
  } catch (error) {
    ErrorManagement.exception({
      exception: error,
      extra: {
        conversationId,
      },
      tags: {
        fileLocation: 'zendesk-chat-server.ts',
        featureFunction: 'clearZendeskConversationMessagesOnServer',
      },
      fingerprint: ['clear-zendesk-conversation-messages-failed'],
    });
  }
};
